import React, { Fragment } from 'react'

interface Props{
    show: boolean,
    children: React.ReactNode
}
const VisibilityBox = ({show, children}:Props) => {
  return (
    <Fragment>
      { show && children}
    </Fragment>
  )
}

export default VisibilityBox